import React from "react";
import FarmerCityNavbar from ".././components/HomePage/FarmerCityNavbar";
import RentLease from ".././components/HomePage/RentLease";
import HeroSec from ".././components/HomePage/HeroSec";
import ShopByCategory from ".././components/HomePage/ShopByCategory";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import BlogsCards from "../components/Blogs/BlogsCards";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import ServicesSection from "../components/ServicesSection/ServicesSection";

const Home = () => {
  return (
    <div>
      {/* <FarmerCityNavbar /> */}
      <CommonNavbar/>
      <RentLease />
      <ServicesSection />
      {/* <HeroSec /> */}
      {/* <ShopByCategory /> */}
      {/* <BlogsCards /> */}
      <CommonFooter />
    </div>
  );
};

export default Home;
